var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-screen"},[(_vm.showTariffsBurnRate)?_c('TariffsRate',{attrs:{"user-info":_vm.getUserInfo}}):_vm._e(),_c('GroupsFilter'),_c('MainGroups',{attrs:{"groups-data":_vm.getGroupsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }